export const breakpoints = {
  xss: "0",
  xs: "300", // galaxy fold and lower
  sm: "576",
  md: "768",
  lg: "992",
  xl: "1200",
  xxl: "1400"
};
